import React, { Component } from "react";
import styles from "../Modules/Footer.module.css";
import { faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Footer extends Component {
  render() {
    return (
      <div id={styles.footer}>
        <div className={styles.socials}>
          <a
            href="https://www.linkedin.com/in/soulaimane-elmanioui/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FontAwesomeIcon className={styles.social_link} icon={faLinkedinIn} />
          </a>
          <a
            href="https://github.com/soulaimanedev"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FontAwesomeIcon className={styles.social_link} icon={faGithub} />
          </a>
        </div>
        <span className={styles.copyright}>
          © {new Date().getFullYear()} Soulaimane ELManioui — Built with React
        </span>
      </div>
    );
  }
}

export default Footer;
